import { Building2, BadgePercent, Users2, KeyRound, HardHat, FileSignature, FolderLock, GraduationCap, ShieldCheck } from 'lucide-react';
import { R } from '@/lib/routes';

// Canonical KesarOne ecosystem module taxonomy. `crm`, `commissions`, `admin_ops`
// and `proposals` are live workspaces; `systems` is a Root-Admin-only control hub
// (rootOnly — never user-mappable); the rest render as greyed "Coming Soon" tiles.
export const MODULES = [
  { key: 'crm', label: 'CRM', desc: 'Inventory, EOIs, Bookings, Legal & Recovery', icon: Building2, color: '#245329', bg: '#E6F4EA', available: true, route: R.overview },
  { key: 'commissions', label: 'Commissions', desc: 'Channel partner & internal brokerage payouts', icon: BadgePercent, color: '#B26A00', bg: '#FFF4E0', available: true, route: R.commissionsHub },
  { key: 'admin_ops', label: 'Admin Module', desc: 'Locations, expenses, assets, fleet & procurement', icon: Users2, color: '#1565C0', bg: '#E3F2FD', available: true, route: R.adminOps },
  { key: 'systems', label: 'Systems', desc: 'Identity, access control, geo-fencing & security logs', icon: ShieldCheck, color: '#111827', bg: '#E5E7EB', available: true, route: R.systems, rootOnly: true },
  { key: 'handover', label: 'Project Handover', desc: 'Society formation, handover docs & customer body', icon: KeyRound, color: '#6A1B9A', bg: '#F3E5F5', available: false },
  { key: 'site', label: 'Site Management', desc: 'On-site engineering, materials & construction milestones', icon: HardHat, color: '#00695C', bg: '#E0F2F1', available: false },
  { key: 'proposals', label: 'Proposals', desc: 'Land & project acquisition, negotiations & site recky', icon: FileSignature, color: '#8B1E1E', bg: '#FCE8E8', available: true, route: R.proposalsHub },
  { key: 'documents', label: 'Documents Library', desc: 'Centralized enterprise digital vault', icon: FolderLock, color: '#37474F', bg: '#ECEFF1', available: false },
  { key: 'lms', label: 'LMS', desc: 'Departmental training tracks & modules', icon: GraduationCap, color: '#AD1457', bg: '#FCE4EC', available: false },
];

export const MODULE_MAP = Object.fromEntries(MODULES.map((m) => [m.key, m]));

// Post-login destination: single-module users go straight into their one live
// workspace; everyone mapped to more than one module lands on the Hub.
export const landingFor = (user) => {
  const mods = user?.modules || [];
  if (mods.length === 1) {
    const m = MODULE_MAP[mods[0]];
    return m && m.available && m.route ? m.route : R.hub;
  }
  return R.hub;
};
